// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { DataTableProps } from "@insite/mobius/DataTable";
import { GridItemProps } from "@insite/mobius/GridItem";
import { GridContainer, GridItem, Typography } from "@insite/mobius/index";
import { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useLocalizeCurrency from "@store/Framework/Common/Hooks/useLocalizeCurrency";
import { ProductData, ProductDataLineItems } from "@store/Framework/Types/types";
import ReportDataTable, {
    DataTableData,
    FormatDictionary,
} from "@store/Library/Components/Reporting/ApiDataTable/ReportDataTable";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { getMediaQuery } from "@toolkit/Framework/Common/Utilities/mediaQueries";
import React from "react";
import styled, { css } from "styled-components";

const tabletQuery = getMediaQuery({ option: "only", first: true, min: 0, max: 1200, last: false });

export interface ProductSectionStyles {
    productSectionContainer?: InjectableCss;
    productHeading?: InjectableCss;
    productHeadingTypography?: TypographyProps;
    productDataTable?: DataTableProps;
    dataTableGridItem?: GridItemProps;
}

export const ProductSectionStyles: ProductSectionStyles = {
    dataTableGridItem: {
        width: 12,
        css: css`
            padding-inline: 2.75rem;
            padding-bottom: 0rem;
            overflow: auto;
        `,
    },
    productSectionContainer: {
        css: css`
            width: 90%;
            margin: 1rem;
            align-self: center;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
            border-radius: 0.5rem;
            padding-bottom: 3rem;
            margin-top: 2rem;
            margin-left: 1rem;
            ${tabletQuery} {
                width: 100%;
            }
            justify-content: center;
            background-color: ${getColor("primary")};
            display: flex;
            flex-direction: column;
            align-items: center;
            row-gap: 1rem;
        `,
    },
    productHeading: {
        css: css`
            font-weight: 700;
            width: 100%;
            display: flex;
            ${tabletQuery} {
                flex-direction: column;
                justify-content: center;
                row-gap: 1.25rem;
            }
            align-items: center;
            padding: 0rem 1.5rem;
            justify-content: space-between;
        `,
    },
    productHeadingTypography: {
        css: css`
            color: white;
            ${tabletQuery} {
                text-align: center;
            }
        `,
    },
};
export const ProductHeading = styled.div`
    font-weight: 700;
    width: 100%;
    display: flex;
    ${tabletQuery} {
        flex-direction: column;
        justify-content: center;
        row-gap: 1.25rem;
    }
    align-items: center;
    padding: 0rem 1.5rem;

    justify-content: space-between;
`;
export const ProductHeadingTypography = styled(Typography)`
    color: white;
    ${tabletQuery} {
        text-align: center;
    }
`;

export const ProductTitle = styled(Typography)`
    color: white;
    max-width: 50%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    ${tabletQuery} {
        text-align: center;
        max-width: unset;
    }
`;
export const ProductSectionContainer = styled.div`
    width: 90%;
    margin: 1rem;
    align-self: center;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    border-radius: 0.5rem;
    padding-bottom: 3rem;
    margin-top: 2rem;
    margin-left: 1rem;
    ${tabletQuery} {
        width: 100%;
    }
    justify-content: center;
    background-color: ${getColor("primary")};

    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 1rem;
`;
interface Props {
    extendedStyles?: ProductSectionStyles;
    overrideStyles?: ProductSectionStyles;
    productData: ProductData;
    itemName: string;
    formatDictionary?: FormatDictionary;
    headers: string[];
    dataKeys: (keyof ProductDataLineItems)[];
}
const ProductSection: React.FC<Props> = ({
    productData,
    dataKeys,
    headers,
    itemName,
    formatDictionary,
    extendedStyles,
    overrideStyles,
}) => {
    const styles = useExpandProps(ProductSectionStyles, extendedStyles, overrideStyles);
    const { itemNumber, data } = productData;
    const localizeCurrency = useLocalizeCurrency();
    const tableData: DataTableData<ProductDataLineItems> = {
        headers,
        dataKeys,
        data: data || [],
        title: "Expenditure By Product",
        formatDictionary,
    };
    return (
        <StyledWrapper {...styles.productSectionContainer}>
            <GridContainer
                offsetCss={css`
                    justify-content: center;
                `}
            >
                <GridItem
                    width={12}
                    css={css`
                        padding-bottom: 0;
                    `}
                >
                    <StyledWrapper {...styles.productHeading}>
                        <ProductHeadingTypography variant="h4">
                            {itemNumber
                                ? `${translate("Item #")} ${itemNumber || ""}`
                                : `${translate("Total Quantity:")} ${productData?.totQuantity}`}
                        </ProductHeadingTypography>

                        <ProductTitle variant="h4">{itemName} </ProductTitle>
                        <ProductHeadingTypography variant="h4">
                            <ProductHeadingTypography>
                                {`${translate("Total")}: ${localizeCurrency(productData?.totCost) || ""}`}
                            </ProductHeadingTypography>
                            <ProductHeadingTypography variant="h4">
                                {itemNumber && `${translate("Total Quantity:")} ${productData?.totQuantity}`}
                            </ProductHeadingTypography>
                        </ProductHeadingTypography>
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.dataTableGridItem}>
                    <ReportDataTable
                        searchable={false}
                        pagination={false}
                        showExportButton={false}
                        dataTableData={tableData}
                        {...styles.productDataTable}
                    />
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

export default ProductSection;
